import React from "react";
import HorizontalRule from "../../../components/components/atoms/HorizontalRule";
import { useSelector } from "react-redux";
import { RootState } from "../../../../../models/rootState";
import { Header } from "../../components/atoms/Header";
import { CustomerContactInfo } from "../../components/molecules/CustomerContactInfo";
import { CustomerCreditCheck } from "../../components/molecules/CustomerCreditCheck";
import { CustomerDeals } from "../../components/molecules/CustomerDeals";
import { Identification } from "../../components/molecules/Identification";
import { hasCustomerLookupOrCreditCheckBeenPerformed } from "../../state/selectors/customerSelectors";
import ImportantNewsBanner from "../../components/molecules/ImportantNewsBanner/ImportantNewsBanner";

const Customer: React.FC = () => {
    const isCustomerDataFetched = useSelector((state: RootState) => hasCustomerLookupOrCreditCheckBeenPerformed(state));

    return (
        <div className="retailer-dashboard-wrapper">
            <ImportantNewsBanner />
            <Header text="Kunde" />
            <div>
                <Identification />
                <HorizontalRule />
                <CustomerCreditCheck />
                <HorizontalRule />
                <CustomerDeals />
                {isCustomerDataFetched && (
                    <>
                        <HorizontalRule />
                        <CustomerContactInfo />
                    </>
                )}
            </div>
        </div>
    );
};

export default Customer;
